import { useEffect } from "react";
import { usePortalBranding } from "@/contexts/portalBranding";
import { setPortalTheme } from "@/theme/brandTheme";

interface PortalBrandingThemeProps {
  /**
   * Which branding source this mount speaks for. `host` at the app root (the
   * page hostname, so login/signup/password pages are themed before anyone
   * signs in); `scope` inside the affiliate shell (the signed-in affiliate's
   * home brand). See brandTheme.setPortalTheme for how the two combine.
   */
  layer: "host" | "scope";
}

/**
 * Applies the white-label brand's accent colours as the portal's runtime
 * theme (ticket 11) — the colour counterpart of PortalBrandingHead.
 *
 * Renders nothing. With no brand colour (unbranded, or a BASIC-tier portal
 * that gets name and logo only) it clears its layer, and the default
 * Reveshare scale from index.css stays in place.
 */
export function PortalBrandingTheme({ layer }: PortalBrandingThemeProps) {
  const { isWhiteLabel, primaryColour, secondaryColour } = usePortalBranding();

  useEffect(() => {
    setPortalTheme(
      layer,
      isWhiteLabel && primaryColour
        ? { primary: primaryColour, secondary: secondaryColour }
        : null
    );
    return () => setPortalTheme(layer, null);
  }, [layer, isWhiteLabel, primaryColour, secondaryColour]);

  return null;
}
